import { BaseConverter } from "@converter/BaseConverter";
import { AccomodationTranslationLocation } from "@models/accomodation-translation-location";
import { AccomodationTranslationLocationDto } from "@dtos/accomodation-translation-location.dto";
import { LocationConverter } from "./locationConverter";
import { AccomodationTranslationConverter } from "./accomodationTranslationConverter";

export class AccomodationTranslationLocationConverter extends BaseConverter<AccomodationTranslationLocation, AccomodationTranslationLocationDto>{
    private accomodationConverter = new AccomodationTranslationConverter()
    private location = new LocationConverter();

    modelToDto(model: AccomodationTranslationLocation): AccomodationTranslationLocationDto {
        return new AccomodationTranslationLocationDto(
          model.location ? this.location.modelToDto(model.location): undefined,
          model.accomodationTranslationDto? this.accomodationConverter.modelToDto(model.accomodationTranslationDto) : undefined  
        )
    }

    dtoToModel(dto: AccomodationTranslationLocationDto): AccomodationTranslationLocation {
        return new AccomodationTranslationLocation(
            dto.location ? this.location.dtoToModel(dto.location): undefined,
            dto.accomodationTranslationDto ? this.accomodationConverter.dtoToModel(dto.accomodationTranslationDto) : undefined
        )
        
    }
}